import { Grid } from '@material-ui/core';
import styled, { css } from 'styled-components';

interface styleType {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  left?: number;
  top?: number;
  isElementOver?: boolean;
  isOpenTooltip?: boolean;
  captureImage?: string;
  isMouseOverTargetElement?: boolean | null;
}

export const PageScreenShotWrapper = styled(Grid)`
  position: relative;
`;

export const PageScreenShotImg = styled.img`
  width: 100%;
  border-radius: 16px;
`;

export const TestBox = styled.div`
  position: absolute;
  left: 454px;
  top: 282px;
  width: 10px;
  height: 10px;
  background-color: red;
`;

export const ElementBox = styled.div<{
  isTarget: boolean;
  isMouseOverTargetElement: boolean | null;
  x: number;
  y: number;
  width: number;
  height: number;
  depth: number;
}>`
  position: absolute;
  left: 0;
  top: 0;
  border: solid 1px ${(props) => props.theme.colors.warning5};
  cursor: pointer;
  ${(props) => {
    if (props.isTarget && !props.isMouseOverTargetElement) {
      return css`
        border: solid 1px ${props.theme.colors.purple3};
        background-color: rgba(181, 151, 247, 0.6);
      `;
    }
    return css``;
  }}

  ${(props) => {
    if (
      props.width !== null &&
      props.height !== null &&
      props.x !== null &&
      props.y !== null &&
      props.depth !== null
    ) {
      return css`
        left: ${props.x}px;
        top: ${props.y}px;
        width: ${props.width}px;
        height: ${props.height}px;
        z-index: ${props.depth + 10};
        :hover {
          border: solid 1px ${props.theme.colors.orange5};
          background-color: rgba(255, 153, 49, 0.4);
        }
      `;
    }
    return css``;
  }}
`;

export const ElementLineSVG = styled.svg`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

export const ElementCircle = styled.div<{
  $isTarget: boolean;
  $x: number;
  $y: number;
  $width: number;
  $height: number;
  $rank: number;
  $size: number;
}>`
  font-family: 'RobotoR', 'NotoKrR';
  line-height: normal;
  font-size: 16px;
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
  cursor: pointer;
  background-color: white;
  border: solid 1px ${(props) => props.theme.colors.grey300};

  ${(props) => {
    if (props.$isTarget) {
      return css`
        color: white;
        border: solid 1px ${props.theme.colors.warning5};
        background-color: #f5ab35;
      `;
    }
    return css``;
  }}

  ${(props) => {
    if (
      props.$width !== null &&
      props.$height !== null &&
      props.$x !== null &&
      props.$y !== null &&
      props.$rank !== null
    ) {
      return css`
        left: ${props.$x + props.$width / 2}px;
        top: ${props.$y + props.$height / 2}px;
        transform: translate(-50%, -50%);
        width: ${props.$size}px;
        height: ${props.$size}px;
        border-radius: ${props.$size / 2}px;
        z-index: ${100 - props.$rank};
        :hover {
          color: white;
          border: solid 1px ${props.theme.colors.warning5};
          background-color: #f5ab35;
        }
      `;
    }
    return css``;
  }}
`;

export const ElementCirclePlus = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  transform: translate(0%, -50%);
  padding: 4px 8px 4px 8px;
  height: 24px;
  background-color: white;
  font-family: 'RobotoR', 'NotoKrR';
  line-height: normal;
  font-size: 12px;
  color: #f5ab35;
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px #f5ab35;
  border-radius: 12px;
  z-index: auto;
`;

export const ExtraElementWrapperInner = styled.div`
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
`;

export const ExtraElementWrapper = styled.div<{ $isOpen: boolean | null }>`
  position: absolute;
  bottom: -11px;
  right: 0px;
  transform: translate(0%, 100%);
  min-height: 56px;

  border-radius: 8px;
  display: none;
  /* align-content: stretch; */

  /* align-items: center; */
  /* justify-content: space-between; */
  flex-direction: column;
  padding: 8px 8px 8px 8px;
  border: solid 1px #f5ab34;
  background-color: white;

  ::after {
    position: absolute;
    transform: translate(0%, -100%);
    top: 1px;
    right: 8px;
    width: 0px;
    height: 0px;
    border-bottom: solid 7px white;
    border-left: solid 4px transparent;
    border-right: solid 4px transparent;
    content: '';
  }
  ::before {
    position: absolute;
    transform: translate(0%, -100%);
    top: 0px;
    right: 8px;
    width: 0px;
    height: 0px;
    border-bottom: solid 7px #f5ab34;
    border-left: solid 4px transparent;
    border-right: solid 4px transparent;
    content: '';
  }
  ${(props) => {
    if (props.$isOpen) {
      return css`
        display: flex;
      `;
    }
    return css``;
  }}
`;

export const ExtraElementItem = styled.div`
  width: 40px;

  height: 40px;
  border-radius: 20px;
  border: solid 1px ${(props) => props.theme.colors.grey300};
  display: flex;
  flex-grow: 0;
  justify-content: center;
  align-items: center;
  font-family: 'RobotoR', 'NotoKrR';
  line-height: normal;
  background-color: white;
  font-size: 16px;
  color: #333333;
  margin: 4px;
  :hover {
    color: white;
    border: solid 1px ${(props) => props.theme.colors.warning5};
    background-color: #f5ab35;
  }
`;

export const HeatmapCanvas = styled.div`
  position: absolute !important;
  left: 0;
  top: 0;
  ${(props: styleType) => {
    if (props.width && props.height) {
      return css`
        width: ${props.width}px;
        height: ${props.height}px;
      `;
    }
    return css``;
  }}
`;

export const HeatmapTooltipClick = styled.div<{
  isOpenTooltip: boolean;
  left: number;
  top: number;
  tooltipCase: number;
  isMouseOverTargetElement: boolean | null;
}>`
  display: none;
  position: absolute;
  background-color: white;
  border-radius: 8px;
  width: 211px;
  height: 217px;
  z-index: 50;
  padding: 16px;
  flex-direction: column;
  ${(props) => {
    switch (props.tooltipCase) {
      case 0:
        return css`
          &:after {
            position: absolute;
            left: 14px;
            top: -10px;
            content: '';
            width: 0px;
            height: 0px;
            border-top: 0px solid none;
            border-bottom: 10px solid white;
            border-right: 7px solid transparent;
            border-left: 7px solid transparent;
          }
        `;

      case 1:
        return css`
          &:after {
            position: absolute;
            right: 14px;
            top: -10px;
            content: '';
            width: 0px;
            height: 0px;
            border-top: 0px solid none;
            border-bottom: 10px solid white;
            border-right: 7px solid transparent;
            border-left: 7px solid transparent;
          }
        `;

      case 10:
        return css`
          &:after {
            position: absolute;
            left: 14px;
            bottom: -10px;
            content: '';
            width: 0px;
            height: 0px;
            border-top: 10px solid white;
            border-bottom: 0px solid none;
            border-right: 7px solid transparent;
            border-left: 7px solid transparent;
          }
        `;

      case 11:
        return css`
          &:after {
            position: absolute;
            right: 14px;
            bottom: -10px;
            content: '';
            width: 0px;
            height: 0px;
            border-top: 10px solid white;
            border-bottom: 0px solid none;
            border-right: 7px solid transparent;
            border-left: 7px solid transparent;
          }
        `;
      default:
        return css``;
    }
  }}
  ${(props) => {
    if (
      props.isOpenTooltip &&
      props.left &&
      props.top &&
      !props.isMouseOverTargetElement
    ) {
      return css`
        display: flex;
        left: ${props.left}px;
        top: ${props.top}px;
      `;
    }
    return css`
      display: none;
    `;
  }}
`;

export const HeatmapTooltipHover = styled.div<{
  isOpenTooltip: boolean;
  left: number;
  top: number;
  tooltipCase: number;
}>`
  display: none;
  position: absolute;
  background-color: white;
  border-radius: 8px;
  width: 211px;
  height: 217px;
  z-index: 999;
  padding: 16px;
  flex-direction: column;
  ${(props) => {
    switch (props.tooltipCase) {
      case 0:
        return css`
          &:after {
            position: absolute;
            left: 14px;
            top: -10px;
            content: '';
            width: 0px;
            height: 0px;
            border-top: 0px solid none;
            border-bottom: 10px solid white;
            border-right: 7px solid transparent;
            border-left: 7px solid transparent;
          }
        `;

      case 1:
        return css`
          &:after {
            position: absolute;
            right: 14px;
            top: -10px;
            content: '';
            width: 0px;
            height: 0px;
            border-top: 0px solid none;
            border-bottom: 10px solid white;
            border-right: 7px solid transparent;
            border-left: 7px solid transparent;
          }
        `;

      case 10:
        return css`
          &:after {
            position: absolute;
            left: 14px;
            bottom: -10px;
            content: '';
            width: 0px;
            height: 0px;
            border-top: 10px solid white;
            border-bottom: 0px solid none;
            border-right: 7px solid transparent;
            border-left: 7px solid transparent;
          }
        `;

      case 11:
        return css`
          &:after {
            position: absolute;
            right: 14px;
            bottom: -10px;
            content: '';
            width: 0px;
            height: 0px;
            border-top: 10px solid white;
            border-bottom: 0px solid none;
            border-right: 7px solid transparent;
            border-left: 7px solid transparent;
          }
        `;
      default:
        return css``;
    }
  }}
  ${(props) => {
    if (props.isOpenTooltip && props.left && props.top) {
      return css`
        display: flex;
        left: ${props.left}px;
        top: ${props.top}px;
      `;
    }
    return css`
      display: none;
    `;
  }}
`;

export const HeatmapTooltipHover2 = styled.div<{
  $isOpenTooltip: boolean;
  $left: number;
  $top: number;
  $tooltipCase: number;
}>`
  display: none;
  position: absolute;
  background-color: white;
  border-radius: 8px;
  width: 211px;
  height: 217px;
  z-index: 50;
  padding: 16px;
  flex-direction: column;
  ${(props) => {
    switch (props.$tooltipCase) {
      case 0:
        return css`
          &:after {
            position: absolute;
            left: 14px;
            top: -10px;
            content: '';
            width: 0px;
            height: 0px;
            border-top: 0px solid none;
            border-bottom: 10px solid white;
            border-right: 7px solid transparent;
            border-left: 7px solid transparent;
          }
        `;

      case 1:
        return css`
          &:after {
            position: absolute;
            right: 14px;
            top: -10px;
            content: '';
            width: 0px;
            height: 0px;
            border-top: 0px solid none;
            border-bottom: 10px solid white;
            border-right: 7px solid transparent;
            border-left: 7px solid transparent;
          }
        `;

      case 10:
        return css`
          &:after {
            position: absolute;
            left: 14px;
            bottom: -10px;
            content: '';
            width: 0px;
            height: 0px;
            border-top: 10px solid white;
            border-bottom: 0px solid none;
            border-right: 7px solid transparent;
            border-left: 7px solid transparent;
          }
        `;

      case 11:
        return css`
          &:after {
            position: absolute;
            right: 14px;
            bottom: -10px;
            content: '';
            width: 0px;
            height: 0px;
            border-top: 10px solid white;
            border-bottom: 0px solid none;
            border-right: 7px solid transparent;
            border-left: 7px solid transparent;
          }
        `;
      default:
        return css``;
    }
  }}
  left: ${(props) => props.$left}px;
  top: ${(props) => props.$top}px;

  ${(props) => {
    if (props.$isOpenTooltip) {
      return css`
        display: flex;
      `;
    }
    return css`
      display: none;
    `;
  }}
`;

export const HeatmapTooltipThumbnailWrapper = styled.div`
  width: 100%;
  height: 101px;
  background-color: #f7f7f8;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeatmapTooltipThumbnailImg = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
`;

export const HeatmapTooltipSplit = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${(props) => props.theme.colors.grey200};
  margin-top: 8px;
`;

export const HeatmapTooltipDataRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  width: 100%;
`;

export const HeatmapTooltipDataTitle = styled.div`
  font-family: 'RobotoR', 'NotoKrR';
  font-size: 12px;
  line-height: 2.08;
  color: ${(props) => props.theme.colors.grey600};
  height: 17px;
`;

export const HeatmapTooltipDataValue = styled.div`
  font-family: 'RobotoB', 'NotoKrB';
  font-size: 12px;
  line-height: 2.08;
  color: ${(props) => props.theme.colors.grey800};
  height: 17px;
`;

export const DeviceTypeWrapper = styled(Grid)``;

export const BlurWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.6;
  border-radius: 16px;
`;

export const Dot = styled.div`
  position: absolute;
  width: 2px;
  height: 2px;
  background-color: black;
  ${(props: styleType) => {
    if (props.left && props.top) {
      return css`
        left: ${props.left}px;
        top: ${props.top}px;
        transform: translate(-50%, -50%);
      `;
    }
    return css``;
  }}
`;

interface CrossHairProps {
  x: number;
  y: number;
  width: number;
  height: number;
  isMouseOverTargetElement: boolean | null;
}

export const CrossHairTop = styled.div`
  position: absolute;
  background-color: ${(props) => props.theme.colors.purple3};
  width: 1px;
  top: 0px;
  ${(props: CrossHairProps) => {
    if (
      props.width !== null &&
      props.height !== null &&
      props.y !== null &&
      props.x !== null &&
      !props.isMouseOverTargetElement
    ) {
      return css`
        height: ${props.y}px;
        left: ${props.x + props.width / 2}px;
      `;
    }
    return css`
      display: 'none';
    `;
  }}
`;
export const CrossHairBottom = styled.div`
  position: absolute;
  background-color: ${(props) => props.theme.colors.purple3};
  width: 1px;
  bottom: 0px;
  ${(props: CrossHairProps) => {
    if (
      props.width !== null &&
      props.height !== null &&
      props.y !== null &&
      props.x !== null &&
      !props.isMouseOverTargetElement
    ) {
      return css`
        top: ${props.y + props.height}px;
        left: ${props.x + props.width / 2}px;
      `;
    }
    return css`
      display: 'none';
    `;
  }}
`;
export const CrossHairLeft = styled.div`
  position: absolute;
  background-color: ${(props) => props.theme.colors.purple3};
  height: 1px;
  left: 0px;
  ${(props: CrossHairProps) => {
    if (
      props.width !== null &&
      props.height !== null &&
      props.y !== null &&
      props.x !== null &&
      !props.isMouseOverTargetElement
    ) {
      return css`
        width: ${props.x}px;
        top: ${props.y + props.height / 2}px;
      `;
    }
    return css`
      display: 'none';
    `;
  }}
`;
export const CrossHairRight = styled.div`
  position: absolute;
  background-color: ${(props) => props.theme.colors.purple3};
  height: 1px;
  right: 0px;
  ${(props: CrossHairProps) => {
    if (
      props.width !== null &&
      props.height !== null &&
      props.y !== null &&
      props.x !== null &&
      !props.isMouseOverTargetElement
    ) {
      return css`
        left: ${props.x + props.width}px;
        top: ${props.y + props.height / 2}px;
      `;
    }
    return css`
      display: 'none';
    `;
  }}
`;
